/**
 * INT-01/05 — `/criar/:tipo`: lê o link uma vez, espera pacientes (e modelos, para `pacote`)
 * e troca a entrada do histórico por `/documentos` com o `state` preenchido. A barra de
 * endereço não guarda nome de paciente nem remédio.
 */
import { useEffect, useRef, useState } from 'react'
import { Navigate, useParams, useSearchParams } from 'react-router-dom'
import { useClinicalDocumentStore } from '@/features/clinicalDocuments/model/clinicalDocumentStore'
import { usePatientStore } from '@/features/patients/model/patientStore'
import { intentToNavigationState } from './intentNavigation'
import { trackProductEvent } from '@/shared/lib/posthog/trackProductEvent'
import { intentAnalytics, parseIntentParams } from './parseIntentParams'

export function IntentRoute() {
  const { tipo } = useParams()
  const [searchParams] = useSearchParams()
  const [intent] = useState(() => parseIntentParams(tipo, searchParams))
  const patients = usePatientStore((state) => state.patients)
  const patientsLoaded = usePatientStore((state) => state.loaded)
  const fetchPatients = usePatientStore((state) => state.fetchPatients)
  const templates = useClinicalDocumentStore((state) => state.templates)
  const templatesLoaded = useClinicalDocumentStore((state) => state.loaded)

  const trackedRef = useRef(false)
  useEffect(() => {
    if (!intent || trackedRef.current) return
    trackedRef.current = true
    trackProductEvent('intent_opened', intentAnalytics(intent, searchParams.get('src')))
  }, [intent, searchParams])

  const needsPatients = Boolean(intent?.patient) && !patientsLoaded
  useEffect(() => {
    if (needsPatients) void fetchPatients().catch(() => undefined)
  }, [needsPatients, fetchPatients])

  if (!intent) return <Navigate to="/documentos" replace />
  const waitingTemplates = intent.kind === 'exames' && Boolean(intent.packageName) && !templatesLoaded
  if (needsPatients || waitingTemplates) {
    return <p className="p-4 text-sm text-[var(--color-text-muted)]">Abrindo o documento…</p>
  }
  return <Navigate to="/documentos" replace state={intentToNavigationState(intent, { patients, templates })} />
}
